import { render, staticRenderFns } from "./ScoreTag.vue?vue&type=template&id=10bd4171&scoped=true&"
import script from "./ScoreTag.vue?vue&type=script&lang=js&"
export * from "./ScoreTag.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTag.vue?vue&type=style&index=0&id=10bd4171&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd4171",
  null
  
)

export default component.exports